module.exports = __webpack_public_path__ + "media/images/landkit/icons/payment-methods/paypal-4ad51a3788c09a14001d74a3a6d7a0b8.svg";